
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/journal",
      function () {
        return require("private-next-pages/[lang]/journal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/journal"])
      });
    }
  